import React from "react";
import {Page} from "../../../components/page/page";
import styles from "./perfect-match.module.css";
import Image from "../../../images/couple2.png";

const PerfectMatchPage = () => {
    const buttonStyles = {
        backgroundColor: "rgb(255, 209, 40)",
        border: "1px solid rgb(255, 209, 40)",
        color: "#000000",
        fontSize: '18px',
        boxShadow: 'none',
        borderRadius: '150px',
        position: "absolute",
        bottom: "30px",
        width: "90%",
        zIndex: "5",
        maxWidth: "500px",
        boxSizing: "border-box",
        left: "20px",
        right: "20px"
    };

    const headerStyles = {
        backgroundColor: "transparent",
    }

    return (
        <div className={styles.container_page}>
            <Page title={["Your perfect match ", <span>could be closer</span>, " than you think!"]}
                  nextPageLink="../your-birthdate" buttonStyles={buttonStyles} currentStep="8" headerStyles={headerStyles} isWhiteLogo={true} isWhiteButton={true}>
                <p className={styles.text}>
                    Let’s explore your astrological chart to discover how to build a happy relationship and find your
                    true path in life. ✨
                </p>
                <img className={styles.couple_image} src={Image} alt=""/>
            </Page>
        </div>
    );
}

export {PerfectMatchPage};